import { useCallback } from 'react'
import { useFormikContext } from 'formik'
import { ISalesFunnelStage } from '@user/store/salesFunnel'
import { LeadAssignmentRuleFormModel } from '../../../../typings'

export function useHandlers({ name }) {
  const { setFieldValue } = useFormikContext<LeadAssignmentRuleFormModel>()

  const handelChange = useCallback(
    (value: ISalesFunnelStage | null) => {
      setFieldValue(name, value?.id)
    },
    [name, setFieldValue],
  )

  return {
    handelChange,
  }
}
